'use strict';

import getPrice from './getPrice';
import activateToolTip from './activateTooltip';
import updateSubmitButton from './updateSubmitButton';

let priceTimeout = null;
const validations = {
  vat: false,
  coupon: false
};

function updateForm (refreshPrice, validCoupon, validVat) {
  validations.vat = validVat;
  validations.coupon = validCoupon;

  if (refreshPrice) {
    clearTimeout(priceTimeout);
    priceTimeout = setTimeout(() => {
      getPrice(validCoupon, validVat);
    }, 300);
  }
  activateToolTip();
  updateSubmitButton();
}

module.exports = updateForm;
